import loadable from '@loadable/component'

export enum INVITE_PAGE_TYPE {
  union = 'union',
  richer = 'richer',
  // 支持高级币商邀请分销商确认
  distributor = 'distributor',
}
const invitePageTypes = [
  INVITE_PAGE_TYPE.union,
  INVITE_PAGE_TYPE.richer,
  INVITE_PAGE_TYPE.distributor,
]

export default [
  {
    path: '/hunting/main',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingMain" */ '~/pages/Hunting/Main'
        )
    ),
  },
  {
    path: '/hunting/policyRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingMain-PolicyRule" */ '~/pages/Hunting/Main/PolicyRule'
        )
    ),
  },
  {
    path: '/hunting/union',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingHuntingUnion" */ '~/pages/Hunting/HuntingUnion'
        )
    ),
  },
  {
    path: '/hunting/details',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingUnionDetails" */ '~/pages/Hunting/UnionDetails'
        )
    ),
  },
  {
    path: '/hunting/invite/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingToBeBD" */ '~/pages/Hunting/ToBeBD'
        )
    ),
  },
  {
    path: `/hunting/inviteUser/:pageType(${invitePageTypes.join(
      '|'
    )})/:mid/:uuid`,
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HuntingUserConfirm" */ '~/pages/Hunting/UserConfirm'
        )
    ),
  },
]
